export const LIST_ALL_TICKET_OUT = 'LIST_ALL_TICKET_OUT';

export const SAVE_TICKET_OUT = 'SAVE_TICKET_OUT';

export const DELETE_TICKET_OUT = 'DELETE_TICKET_OUT';

export const STORE_ALL_TICKET_OUT = 'STORE_ALL_TICKET_OUT';

export const STORE_UPDATED_TICKET_OUT = 'STORE_UPDATED_TICKET_OUT';

// TICKET OUT — Photo Requirement setting
export const GET_TICKET_PHOTO_SETTING = 'GET_TICKET_PHOTO_SETTING';
export const STORE_TICKET_PHOTO_SETTING = 'STORE_TICKET_PHOTO_SETTING';
export const SAVE_TICKET_PHOTO_SETTING = 'SAVE_TICKET_PHOTO_SETTING';
// BONUS
export const SAVE_BONUS = 'SAVE_BONUS';
export const UPLOAD_BONUS_PHOTO = 'UPLOAD_BONUS_PHOTO';
export const DELETE_BONUS = 'DELETE_BONUS';
export const LIST_CLAIM_BONUS = 'LIST_CLAIM_BONUS';
export const STORE_CLAIM_BONUS = 'STORE_CLAIM_BONUS';
export const PREVIEW_BONUS_IMAGE = 'PREVIEW_BONUS_IMAGE';
export const STORE_UPDATED_BONUS_IMAGE_WITH_PREVIEW =
  'STORE_UPDATED_BONUS_IMAGE_WITH_PREVIEW';

//MANAGE BONUS
export const SAVE_MANAGE_BONUS = 'SAVE_MANAGE_BONUS';
export const LIST_MANAGE_BONUS = 'LIST_MANAGE_BONUS';
export const STORE_MANAGE_BONUS = 'STORE_MANAGE_BONUS';
export const DELETE_MANAGE_BONUS = 'DELETE_MANAGE_BONUS';
export const TOGGLE_MANAGE_BONUS = 'TOGGLE_MANAGE_BONUS';

//Transactions

export const LIST_ALL_TRANSACTION = 'LIST_ALL_TRANSACTION';

export const SAVE_TRANSACTION = 'SAVE_TRANSACTION';

export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';

export const STORE_ALL_TRANSACTION = 'STORE_ALL_TRANSACTION';

export const STORE_UPDATED_TRANSACTION = 'STORE_UPDATED_TRANSACTION';

export const TRANSACTION_PDF_PREVIEW = 'TRANSACTION_PDF_PREVIEW';

export const TRANSACTION_STORE_PDF_PREVIEW_READY =
  'TRANSACTION_STORE_PDF_PREVIEW_READY';

export const TRANSACTION_RESET_PDF_PREVIEW_DATA =
  'TRANSACTION_RESET_PDF_PREVIEW_DATA';

export const SAVE_CASH_LEFT_DETAILS = 'SAVE_CASH_LEFT_DETAILS';

export const ROLLOVER_TRANSACTION = 'ROLLOVER_TRANSACTION';
export const STORE_ALL_ROLLOVER_REQUEST_TRANSACTION =
  'STORE_ALL_ROLLOVER_REQUEST_TRANSACTION';

export const ROLLOVER_REQUEST_TRANSACTION = 'ROLLOVER_REQUEST_TRANSACTION';

export const POINT_PDF_PREVIEW = 'POINT_PDF_PREVIEW';

export const POINT_STORE_PDF_PREVIEW_READY = 'POINT_STORE_PDF_PREVIEW_READY';

export const POINT_RESET_PDF_PREVIEW_DATA = 'POINT_RESET_PDF_PREVIEW_DATA';

//MANAGE RULES
export const SAVE_RULES = 'SAVE_RULES';
export const LIST_RULES = 'LIST_RULES';
export const STORE_RULES = 'STORE_RULES';

//report
export const GLOBAL_PDF_PREVIEW = 'GLOBAL_PDF_PREVIEW';
export const GLOBAL_STORE_PDF_PREVIEW_READY = 'GLOBAL_STORE_PDF_PREVIEW_READY';
export const GLOBAL_RESET_PDF_PREVIEW_DATA = 'GLOBAL_RESET_PDF_PREVIEW_DATA';

export const STORE_REPORT_PHOTOS = 'STORE_REPORT_PHOTOS';
